import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';


import Header from '../../components/Header';
import Footer from '../../components/Footer';
import InsideHeader from '../../components/InsideHeader';
import ContactMenu from '../ContactUs/ContactMenu';
import PageIntroBannerAlt from '../../components/PageIntroBannerAlt';
import TestimonialBanner from '../../components/TestimonialBanner';
import CtaBanner from '../../components/CtaBanner';
import ServiceRequestForm from './ServiceRequestForm';

function ServiceRequest({ page }) {
  if (!page) {
    return null;
  }

  return (
    <div>
      <InsideHeader h1="Warranty Service Request" background={page.page_image.contentUrl} />
      <PageHelmet page={page} />
      <Header />
      <ContactMenu />
      <div className="container">
        <div className="row">
          <div className="col">
            <PageIntroBannerAlt
              h2={page.intro_banner[0].main_headline}
              p={page.intro_banner[0].paragraph}
              background={page.intro_banner[0].photo.contentUrl}
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="warranty-form-wrapper">
              <div className="col-lg-12">
                <div className="container">
                  <div className="row">
                    <div className="col-12">
                      <h3 className="form-headline text-center">Submit A Warranty Request</h3>
                      <ServiceRequestForm />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CtaBanner />
      <TestimonialBanner />
      <Footer />
    </div>
  );
}

ServiceRequest.propTypes = {
  page: PropTypes.object,
};

ServiceRequest.defaultProps = {
  page: undefined,
};

export default withData({
  page: 'service_request',
})(ServiceRequest);



// WEBPACK FOOTER //
// ./src/pages/ServiceRequest/index.js